

import React from 'react';
import { connect } from 'react-redux';
import { Button, Input } from 'reactstrap';
import { FaArrowRight } from 'react-icons/fa';
import { setLoginPage, setForgetPasswordDetails, setSiteKey, setUserRegisterDetails } from '../../General/Actions';
import Background from '../../ImageAssets/blueskyBackground.png';
import ValidateForm from '../../Utils/formValidation';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import SignUpComponent from './SignUpComponent';
import GeneralUtils from '../../Utils/generalUtils.js';
import Network from '../../Utils/network.js';
import Swal from 'sweetalert2';

class RechargePhoneNumComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            verified: false,
            siteKey: "",
            fetchServiceDetailsForPWL: []
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    inputValueChange(name, value) {
        this.state.phoneNum = value;
        this.setState({ "dummy": "dummy" })
    }

    loginButtonClicked() {
        this.props.setLoginPage("pageName", "login");
    }

    onVerify = recaptchaResponse => {
        this.setState({
            verified: true
        });
    };

    handleContactNumberOnBlur = () => {
        var formatedDate = GeneralUtils.formatPhoneNumberToUsFormatNew(this.state.phoneNum);
        this.state.phoneNum = formatedDate;
        this.setState({ dummy: "dummy" });
    }


    fetchAccountDetails() {

        if (ValidateForm.inputFieldMandatoryCheck("otpCustomerIdContainer", this.props.locales, false)) {
            if (ValidateForm.inputFieldValueCompositionCheck("otpCustomerIdContainer", this.props.locales, false)) {
                this.setState({ isLoading: true })
                var num = this.state.phoneNum.replace(/\D/g, "");
                Network.executeAxios("fetchServiceInfoForPWL", "POST", { "serviceId": num }, (fetchServiceInfoResponse) => {
                    this.setState({ isLoading: false })
                    if (fetchServiceInfoResponse && fetchServiceInfoResponse.BillingSystem && fetchServiceInfoResponse.BillingSystem.response && fetchServiceInfoResponse.BillingSystem.response.dataset && fetchServiceInfoResponse.BillingSystem.response.dataset.service_info) {
                        var serviceInfo = fetchServiceInfoResponse.BillingSystem.response.dataset.service_info[0]
                        if (serviceInfo.connection_type === "1") {
                            Swal.fire(this.props.locales.pleaseEnterPrepaidNumSwalTitle, "", "");
                        } else {
                            var temp = {}
                            try {
                                temp = {
                                    "firstName": serviceInfo.account_first_name,
                                    "lastName": serviceInfo.account_last_name,
                                    "accountId": serviceInfo.account_id,
                                    "serviceId": num,
                                    "planId": serviceInfo.rate_plan_id
                                }
                            } catch (err) {

                            }
                            this.props.setUserRegisterDetails("accountDetails", temp);
                            this.props.setLoginPage("pageName", "amountForRecharge");
                        }

                    } else {
                        Swal.fire(this.props.locales.internalErrorTitleInSwal, "", "");
                    }
                    // var isContinue = false
                    // if(Object.keys(resp).length == 0){

                    // } else {
                    //   isContinue = true;
                    // }
                    // if(isContinue){
                    //     this.props.setUserRegisterDetails("accountDetails", resp);
                    //     this.props.setLoginPage("pageName", "amountForRecharge");
                    // } else {
                    //     Swal.fire("Account ID is not valid", "","");
                    //     this.setState({isLoading:false})
                    // }

                });
            }
        }
    }

    render() {
        return (
            <div>
                <div id="toastPopup" className="animated slideInRight d-none"></div>
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : null}
                {this.componentContent()}
            </div>
        );
    }

    componentContent() {
        const forgetUsernameOuterMainContainerStyle = { height: (this.state.windowHeight) + 'px', display: "flex", flexDirection: "column", justifyContent: "space-between" };
        return (
            <div style={forgetUsernameOuterMainContainerStyle}>
                <div className="row m-0" style={{ flex: 1 }}>
                    <div className="col-md-6 p-0" >
                        <div style={{ display: "flex", flexDirection: "column", height: "100%", flex: 1, alignItems: "center", justifyContent: "center", background: `url(${Background}) 20%`, backgroundSize: 'cover' }}>
                            <SignUpComponent />
                        </div>
                    </div>
                    <div className="col-md-6 p-0" >
                        <div style={{ display: "flex", height: "100%", flex: 1, justifyContent: "center", backgroundColor: '#ffffff' }}>
                            {this.rechargeComponent()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    rechargeComponent() {
        return (
            <div className="loginPageLeftPart col-md-12 row p-0 m-0 pb-5">
                <div className="col-md-12 row pt-5 m-0 mt-5">

                </div>
                <div className="col-md-12 row m-0">
                    <div className="col-md-1"></div>
                    <div className="col-md-9 pl-sm-5 pl-2 pt-5 mt-5" id="otpCustomerIdContainer">
                        <div className="col-md-12" style={{ fontSize: 30, color: '#404042', fontWeight: 400 }}>{this.props.locales.rechargeBtnTextInLoginPage}</div>
                        <div className="col-md-12 pb-4 pt-2" style={{ fontSize: 14, color: '#404042' }}>{this.props.locales.mobileNumberTextInVoucherPhoneNumberPart}</div>
                        <div className="form-group col-md-12 pb-3" >
                            <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.phoneNumberTextInVoucherPhoneNumberPart}</label>
                            <Input type="text" style={{ color: '#404042' }}
                                className="loginCredItem input_data mandatoryFieldSpecial typeContactNum pt-4 pb-3" placeholder={this.props.locales.phoneNumberTextInVoucherPhoneNumberPart}
                                value={this.state.phoneNum}
                                onChange={(event) => {
                                    this.inputValueChange("phoneNum", event.target.value)
                                    this.handleContactNumberOnBlur();
                                }}
                                onKeyUp={(event) => this.displayLabel(event, this.state.phoneNum, this.props.locales.phoneNumberTextInVoucherPhoneNumberPart)} />
                            <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400, position: 'absolute' }}></div>
                        </div>

                        <div className="col-md-12">
                            <Button className="loginPageLoginButton" disabled={this.state.phoneNum == undefined || this.state.phoneNum == "" ? true : false} style={{ color: '#0049A5', backgroundColor: '#FFFFFF', border: '1px solid #0049A5' }} onClick={() => { this.fetchAccountDetails() }}>
                                {this.props.locales.proceedButtonTextInRechargePhoneNumPart}&nbsp; <FaArrowRight />
                            </Button>
                        </div>

                        <div className="d-flex pt-5 col-md-12 justify-content-center pb-5 mb-5">
                            <div style={{ color: '#0285CA', fontSize: 16, fontWeight: 'bold', cursor: 'pointer' }} onClick={() => { this.signInLinkClicked() }}> {this.props.locales.signInWithOtptInOtpSignInCustomerIdPart}</div>
                        </div>
                    </div>
                    <div className="col-md-2"></div>
                </div>
            </div>
        )
    }

    displayLabel(event, value, placeHolderText) {
        if (value != "") {
            event.target.previousSibling.classList.remove('d-none');
            event.target.placeholder = "";
        } else {
            event.target.previousSibling.classList.add('d-none');
            event.target.placeholder = placeHolderText;
        }
    }
    signInLinkClicked() {
        this.props.setLoginPage("pageName", "customerIdForOTP");
    }

}
const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        siteKey: state.siteKey
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setLoginPage: function (key, payload) {
            dispatch(setLoginPage(key, payload));
        },
        setForgetPasswordDetails: function (key, payload) {
            dispatch(setForgetPasswordDetails(key, payload));
        },
        setSiteKey: function (key, payload) {
            dispatch(setSiteKey(key, payload));
        },
        setUserRegisterDetails: function (key, payload) {
            dispatch(setUserRegisterDetails(key, payload))
        }
    }
}

const RechargePhoneNumComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(RechargePhoneNumComponent)


export default RechargePhoneNumComponentContainer;